<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="6" :lg="6" :md="8" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.name" placeholder="姓名"></Input>
        </Col>
        <Col span="6" :lg="6" :md="8" :sm="12" :xs="24" class="margin-bottom">
        <sl-select :disabled="true" dict="org" v-model="params.orgId" placeholder="所属机构" :filterable="true" />
        </Col>
        <Col span="6" :lg="6" :md="8" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.account" placeholder="账号"></Input>
        </Col>
        <Col span="6" :lg="6" :md="8" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.phone" placeholder="手机号"></Input>
        </Col>
        <Col span="24" :lg="24" :md="24" :sm="24" :xs="24" class="page-action">
        <div>
          <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
          <Button icon="ios-reset" @click="reset()">清空</Button>
        </div>
        <div>
          <Button v-permission="'system.account.org.insert'" type="primary" @click="create()">新增</Button>
        </div>
        </Col>
      </Row>
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-update="handleChange"></sl-table>
    </div>
    <org-user-item ref="item" @on-update="handleUpdate" />
  </sl-page>
</template>
<script>
import orgUserItem from './detail'
import { mapState } from 'vuex'

const displayOrg = (d) => d.organizations ? d.organizations.map(i => i.name).join(';') : ''

const displayRole = (d) => (d.roles || []).map(i => i.name).join(';')

export default {
  components: { orgUserItem },
  data() {
    return {
      columns: [{
          title: '用户名',
          key: 'name',
          minWidth: 90
        },
        {
          title: '所属机构',
          key: 'displayOrg',
          minWidth: 200
        },
        {
          title: '登录名',
          key: 'account',
          minWidth: 100
        },
        {
          title: '手机号',
          key: 'phone',
          minWidth: 150
        },
        {
          title: '角色',
          key: 'displayRole',
          minWidth: 200
        },
        {
          title: '邮箱',
          key: 'email',
          minWidth: 200
        },
        {
          title: '职务',
          key: 'duties',
          minWidth: 200
        },
        {
          title: '创建时间',
          key: 'createDatetimeText',
          minWidth: 160
        },
        {
          title: '状态',
          key: 'statusText',
          minWidth: 150
        },
        {
          title: '操作',
          key: 'action',
          width: 160,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            let acts = []
            if(this.$a('system.account.org.update')){
              acts.push(<a on-click={()=>this.edit(params)}>编辑</a>)
            }
            if(this.$a('system.account.org.enable')){
              acts.push(<a on-click={()=>this.toggle(params)}>{ params.row.status == 0 ? '禁用' : '启用' }</a>)
            }
            if(this.$a('system.account.org.delete')){
              acts.push(<a on-click={()=>this.remove(params)}>删除</a>)
            }
            if(params.row.isLocked && this.$auth.access('system.account.org.unlock')){
              acts.push(<a on-click={()=>this.unlock(params)}>解锁</a>)
            }

            return this.$utils.link(acts,<Divider type="vertical" />)
          }
        }
      ],
      data: [],
      params: {
        account: null,
        phone: null,
        name: null,
        orgId:null
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      orgs:[]
    }
  },
  computed: {
    ...mapState({
      account: state => state.auth.account,
    }),
  },
  created() {
    this.def = { ...this.params }

    // this.$request.organizations({pageSize:9999 , pageNum:1}).then(resp => {
    //   this.orgs = resp.data.list.map( i => ({value:i.id , label:i.name}))
    // })

    this.list()

    ///exam/user/organization/queryPage

  },

  methods: {

    list() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      /*
      if (this.orgId && this.orgId.length) {
        params.search.organtionId = this.orgId[0].id
      }
      */

      this.loading = true
      // this.$request.ciEnterprises(params).then(resp => {
      this.$request.orgUsers(params).then(resp => {
        this.loading = false
        if (resp.code == 0) {
          this.data = this.$utils.conv(resp.data.list || [], { displayOrg, displayRole,  createDatetime: 'datetime', status: '$userState' })
          this.page.total = resp.data.total || 0
        }
      })
    },

    edit({ row }) {
      this.$refs['item'].initData(row)
    },

    create() {
      this.$refs['item'].init()
    },


    view({ row }) {
      this.$refs['item'].init(row.id)
    },

    toggle({ row }) {
      this.$request.orgUserToggle({ id: row.id, status: row.status == 0 ? 1 : 0 }).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.list()
        }
      })
    },
    unlock({ row }){
      this.$ui.confirm(this.$request.userUnlock, `确定解锁用户${record.name}？`)(record.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('解锁成功')
          this.list()
        } else {
          this.$Message.error({ content: resp.msg })
        }
      })
    },
    reset() {
      this.$utils.fill(this.params, this.def)
      this.list()
    },

    remove({ row }) {
      this.$ui.confirm(this.$request.orgUserDelete, `确定删除 ${row.name} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('删除成功')
          this.list()
        } else {
          this.$Message.error(resp.msg)
        }
      })
    },

    handleUpdate() {
      this.list()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

  }
}

</script>
